import { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import styles from './AdminHideFieldsFromSubjectForm.module.scss';
import { adminUpdateSettings } from '../actions/adminAction';
import { getAdminFetchSettings } from '../selectors/adminSelectors';

interface IAdminHideFieldsFromSubjectForm {
  settings: IAdminSetting[];
}

const AdminHideFieldsFromSubjectFormWithoutStore = ({ settings }: IAdminHideFieldsFromSubjectForm) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isHideFieldsSubjectForm = settings?.find(
    setting => setting.code === AdminSettingCodesEnum.ADMIN_SETTING_HIDE_FIELDS_4_1_29,
  );

  const [isHideFields, setIsHideFields] = useState(isHideFieldsSubjectForm?.value === 'true');

  useEffect(() => {
    setIsHideFields(isHideFieldsSubjectForm?.value === 'true');
  }, [settings]);

  const onCheckboxChange = useCallback(() => {
    setIsHideFields(!isHideFields);
  }, [isHideFields]);

  const onSave = useCallback(() => {
    if (!isHideFieldsSubjectForm) return;

    dispatch(
      adminUpdateSettings(
        {
          ...isHideFieldsSubjectForm,
          value: isHideFields ? 'true' : 'false',
        },
        isHideFieldsSubjectForm.id,
      ),
    );
  }, [isHideFields]);

  return (
    <div className={styles.Wrapper}>
      <div className="shared-section-title">Скрыть поля в форме сведения о КЛ</div>
      <Checkbox
        id={'isHideFieldsCheckbox'}
        theme="system"
        onChange={onCheckboxChange}
        checked={isHideFields}
        label={'Скрыть поля'}
        className={styles.CheckBox}
      />
      <Button color="primary" variant="contained" text="Сохранить изменения" onClick={onSave} />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IAdminHideFieldsFromSubjectForm => ({
  settings: getAdminFetchSettings(state),
});

export const AdminHideFieldsFromSubjectForm = connect(mapStateToProps)(AdminHideFieldsFromSubjectFormWithoutStore);
